export default {
	state: {
		shops: [
			{
				id: '001',
				street: ' Историческая, д. 175',
				point: 'АШАН'
			},
			{
				id: '002',
				street: 'Университетский проспект, д. 107',
				point: 'АШАН'
			},
			{
				id: '003',
				street: 'Космонавтов, д. 30',
				point: 'ЛЕНТА'
			},
			{
				id: '004',
				street: 'Университетский, д. 2',
				point: 'ЛЕНТА'
			},
			{
				id: '005',
				street: 'Пролетарская, д. 8',
				point: 'ЛЕНТА'
			},
			{
				id: '006',
				street: 'Университетский, д. 105',
				point: 'ЛЕНТА'
			},
			{
				id: '007',
				street: 'Дзержинского пл. 16',
				point: 'О`КЕЙ'
			}
		]
	},
	mutations: {},
	actions: {},

	getters: {
		getVolgograd (state) {
			return state.shops
		}
	}
}